<div class="create-workspace-container">
    <app-progress-bar [steps]="steps" [currentStep]="step" (stepChanged)="step = $event"
        (nextClicked)="onNextStepRequested()" [isLoading]="isLoading">
    </app-progress-bar>


    <div class="step-content">
        <app-loader class="loader" *ngIf="loaderView"></app-loader>
        <ng-container *ngIf="step === 0">
            <form [formGroup]="workspaceDetails">
                <div class="wrapper-container" *ngIf="!loaderView">
                    <h2 class="section-title">Workspace Details</h2>
                    <div class="workspace-details-container">
                        <div class="workspace-info">
                            <div>
                                <p class="label">Workspace Name <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter Workspace name" type="text" name="workspaceName"
                                    formControlName="workspaceName"
                                    [value]="workspaceDetails.controls['workspaceName'].value"
                                    (change)="onInputChange('workspaceName',$event)"
                                    [disabled]="workspaceDetailsDisable"
                                    [hasError]="workspaceDetailsHasError('workspaceName')"></app-text-field>
                                <small *ngIf="workspaceDetailsHasError('workspaceName')" class="error-message">{{workspaceError['workspaceName']}}</small>
                            </div>
                            <div>
                                <p class="label">Sign-in Method <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="signInMethodList" (value)="getValueOfMethod($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Method'" [shouldEmitEmittedValue]="true"
                                    [disabled]="workspaceDetailsDisable"></app-generic-drop-down>
                            </div>
                        </div>
                        <div class="location-info">
                            <p class="label">Location(s) <span class="required-star">*</span></p>
                            <div class="subsection-container">
                                <ng-container *ngFor="let location of selectedLoactions">
                                    <div class="list-container">
                                        <div class="location-item">
                                            <p class="location-text"> {{ location }} </p>
                                        </div>
                                        <button class="delete-btn" [ngClass]="{'disabled': workspaceDetailsDisable}"
                                            (click)="deleteListData('location', location)"
                                            [disabled]="workspaceDetailsDisable">X</button>
                                    </div>
                                </ng-container>
                                <button type="button" (click)="addControl('location')" class="add-btn"
                                    [disabled]="workspaceDetailsDisable"
                                    [ngClass]="{'disabled': workspaceDetailsDisable}">+ Add
                                    Location</button>
                            </div>
                        </div>
                        <div class="location-info">
                            <p class="label">Allowed Domain(s) <span class="required-star">*</span></p>
                            <div class="subsection-container">
                                <ng-container *ngFor="let domain of allowedDomains">
                                    <div class="list-container">
                                        <div class="location-item">
                                            <p class="location-text"> {{ domain }} </p>
                                        </div>
                                        <button class="delete-btn" [ngClass]="{'disabled': workspaceDetailsDisable}"
                                            (click)="deleteListData('allowedDomains', domain)"
                                            [disabled]="workspaceDetailsDisable">X</button>
                                    </div>
                                </ng-container>
                                <button type="button" (click)="addControl('domain')" class="add-btn"
                                    [disabled]="workspaceDetailsDisable"
                                    [ngClass]="{'disabled': workspaceDetailsDisable}">+ Add
                                    Domain</button>
                            </div>
                        </div>
                        <div class="workspace-info">
                            <div>
                                <p class="label">Acronym Length <span class="required-star">*</span></p>
                                <app-text-field placeholder="Allowed range: 1–4" type="number" name="acronymLength"
                                    formControlName="acronymLength"
                                    [value]="workspaceDetails.controls['acronymLength'].value"
                                    (change)="onInputChange('acronymLength',$event)"
                                    [hasError]="workspaceDetailsHasError('acronymLength')"
                                    [disabled]="workspaceDetailsDisable"></app-text-field>
                                <small *ngIf="workspaceDetailsHasError('acronymLength')" class="error-message">{{workspaceError['acronymLength']}}</small>
                            </div>
                            <div>
                                <p class="label">Initial Asset Number</p>
                                <p class="asset-code-info">The number from which asset numbering will begin (e.g., if
                                    1000, The numbering will start from 1000, 1001, 1002...)</p>
                                <app-text-field placeholder="Enter asset number" type="number" name="initialAssetNumber"
                                    formControlName="initialAssetNumber"
                                    [value]="workspaceDetails.controls['initialAssetNumber'].value"
                                    (change)="onInputChange('initialAssetNumber',$event)"
                                    [hasError]="workspaceDetailsHasError('initialAssetNumber')"
                                    [disabled]="workspaceDetailsDisable"></app-text-field>
                                <small *ngIf="workspaceDetailsHasError('initialAssetNumber')"
                                    class="error-message">Initial Asset number should be
                                    of minimum 4 digits and maximum 5 digits</small>
                            </div>
                        </div>
                        <div class="location-info">
                            <p class="label">Acronym(s) <span class="required-star">*</span></p>
                            <div class="subsection-container">
                                <ng-container *ngFor="let acronym of selectedAcronyms">
                                    <div class="list-container">
                                        <div class="location-item">
                                            <p class="location-text"> {{ acronym }} </p>
                                        </div>
                                        <button class="delete-btn" [ngClass]="{'disabled': workspaceDetailsDisable}"
                                            (click)="deleteListData('acronyms', acronym)"
                                            [disabled]="workspaceDetailsDisable">X</button>
                                    </div>
                                </ng-container>
                                <button
                                    [ngClass]="{'disabled': workspaceDetails!.controls['acronymLength']!.invalid || workspaceDetailsDisable}"
                                    type="button" (click)="addControl('acronym')" class="add-btn"
                                    [disabled]="workspaceDetails!.controls['acronymLength']!.invalid"
                                    [disabled]="workspaceDetailsDisable">+ Add
                                    acronym</button>
                            </div>
                        </div>
                        <div class="asset-code-template">
                            <p class="label">Asset Code Template <span class="required-star">*</span></p>
                            <p class="asset-code-info">This template cannot be updated later. Please review carefully.
                            </p>
                            <div cdkDropList class="subsection-container asset-code"
                                [cdkDropListData]="assetTemplateFields" (cdkDropListDropped)="drop($event)">
                                <div class="drag-item" *ngFor="let item of assetTemplateFields" cdkDrag
                                    [cdkDragDisabled]="workspaceDetailsDisable">
                                    <ng-template cdkDragPreview>
                                        <div class="drag-preview">
                                            <img src="assets/24x24/Dots.svg" alt="">
                                            <span>{{ item }}</span>
                                        </div>
                                    </ng-template>
                                    <ng-template cdkDragPlaceholder>
                                        <div class="drag-placeholder"></div>
                                    </ng-template>
                                    <div class="drag-handle" cdkDragHandle>
                                        <img src="assets/24x24/Dots.svg" alt="">
                                    </div>
                                    <span class="drag-text">{{ item }}</span>
                                </div>
                            </div>
                            <p class="asset-code-info">
                                E.g., asset code as per this order:
                                <span class="example-code">{{ userAssetCode }}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="wrapper-container" *ngIf="!loaderView">
                    <h2 class="section-title">Company Details</h2>
                    <div class="company-info">
                        <div>
                            <p class="label">Company Name <span class="required-star">*</span></p>
                            <app-text-field placeholder="Enter company name" type="text" name="companyName"
                                formControlName="companyName" [value]="workspaceDetails.controls['companyName'].value"
                                (change)="onInputChange('companyName',$event)" [disabled]="workspaceDetailsDisable"
                                [hasError]="workspaceDetailsHasError('companyName')"></app-text-field>
                            <small *ngIf="workspaceDetailsHasError('companyName')" class="error-message">{{workspaceError['companyName']}}</small>
                        </div>
                        <div>
                            <p class="label">Company Website URL <span class="required-star">*</span></p>
                            <app-text-field placeholder="Enter website URL" type="url" name="companyWebsiteLink"
                                formControlName="companyWebsiteLink"
                                [value]="workspaceDetails.controls['companyWebsiteLink'].value"
                                (change)="onInputChange('companyWebsiteLink',$event)"
                                [hasError]="workspaceDetailsHasError('companyWebsiteLink')"
                                [disabled]="workspaceDetailsDisable"></app-text-field>
                            <small *ngIf="workspaceDetailsHasError('companyWebsiteLink')" class="error-message">{{workspaceError['companyWebsiteLink']}}</small>
                        </div>
                        <div>
                            <p class="label">Date of Establishment <span class="required-star">*</span></p>
                            <app-text-field placeholder="Enter year" type="date" name="establishmentDate"
                                formControlName="establishmentDate"
                                [value]="workspaceDetails.controls['establishmentDate'].value"
                                (change)="onInputChange('establishmentDate',$event)" [max]="maxDate"
                                [disabled]="workspaceDetailsDisable"
                                [hasError]="workspaceDetailsHasError('establishmentDate')"></app-text-field>
                            <small *ngIf="workspaceDetailsHasError('establishmentDate')" class="error-message">{{workspaceError['establishmentDate']}}</small>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="step === 1">
            <div class="wrapper-container">
                <h4>User Attributes & Values</h4>
                <div class="attributes-container">
                    <div class="attribute-info">
                        <div *ngFor="let category of assetDetails?.categories" class="card-container">
                            <div class="property-info">
                                <h3>{{ category.displayName}}<span class="required-star"> *</span></h3>
                                <div *ngFor="let config of groupedConfigs[category.name]; let configIndex = index"
                                    class="config-list">
                                    <div class=" config-item">
                                        <span class="values">
                                            <p class="values-heading">Value(s):</p>
                                            <span>
                                                {{ getValuesDisplay(config) }}
                                            </span>
                                        </span>
                                    </div>
                                    <button class="edit-button" (click)="onEditConfig(category.name, configIndex)"
                                        [disabled]="userAttributesDisable">
                                        <img src="assets/14x14/edit_blue.svg" alt="Edit" class="edit-icon"
                                            [ngClass]="{'edit-btn-disabled':userAttributesDisable}">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="step === 2">
            <form [formGroup]="workspaceOwnerDetails">
                <div class="wrapper-container" *ngIf="!loaderView">
                    <h2 class="section-title">Workspace Owner Details</h2>
                    <div class="workspace-owner-details-container">
                        <div class="owner-info">
                            <div>
                                <p class="label">First Name <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter name" type="text" name="firstName"
                                    formControlName="firstName"
                                    [value]="workspaceOwnerDetails.controls['firstName'].value"
                                    (change)="onInputChange('firstName',$event)"
                                    [disabled]="workspaceOwnerDetailsDisable"
                                    [hasError]="workspaceOwnerHasError('firstName')"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('firstName')" class="error-message">Please enter a
                                    valid first name</small>
                            </div>
                            <div>
                                <p class="label">Last Name <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter name" type="text" name="lastName"
                                    formControlName="lastName"
                                    [value]="workspaceOwnerDetails.controls['lastName'].value"
                                    (change)="onInputChange('lastName',$event)"
                                    [disabled]="workspaceOwnerDetailsDisable"
                                    [hasError]="workspaceOwnerHasError('lastName')"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('lastName')" class="error-message">Please enter a
                                    valid last name</small>
                            </div>
                            <div>
                                <p class="label">Employee ID <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter employee ID" type="number" name="empId"
                                    formControlName="empId" [value]="workspaceOwnerDetails.controls['empId'].value"
                                    (change)="onInputChange('empId',$event)" [disabled]="workspaceOwnerDetailsDisable"
                                    [hasError]="workspaceOwnerHasError('empId')"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('empId')" class="error-message">Please enter a
                                    valid Employee ID</small>
                            </div>
                            <div>
                                <p class="label">Email <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter email address" type="email" name="email"
                                    formControlName="email" [value]="workspaceOwnerDetails.controls['email'].value"
                                    (change)="onInputChange('email',$event)"
                                    [hasError]="workspaceOwnerHasError('email')"
                                    [disabled]="workspaceOwnerDetailsDisable"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('email')" class="error-message">Please enter a
                                    valid email</small>
                            </div>
                            <div>
                                <p class="label">Phone <span class="required-star">*</span></p>
                                <app-text-field placeholder="Enter phone number" type="number" name="phoneNumber"
                                    formControlName="phoneNumber"
                                    [value]="workspaceOwnerDetails.controls['phoneNumber'].value"
                                    (change)="onInputChange('phoneNumber',$event)"
                                    [hasError]="workspaceOwnerHasError('phoneNumber')"
                                    [disabled]="workspaceOwnerDetailsDisable"></app-text-field>
                                <small *ngIf="workspaceOwnerHasError('phoneNumber')" class="error-message">Please enter
                                    a valid phone number</small>
                            </div>
                            <div>
                                <p class="label">Type <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="typeList" (value)="getIdOfType($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Method'" [shouldEmitEmittedValue]="true"
                                    [disabled]="workspaceOwnerDetailsDisable"
                                    [createWorkspaceFlag]="true"></app-generic-drop-down>
                            </div>
                            <div>
                                <p class="label">Status <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="statusList" (value)="getIdOfStatus($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Method'" [shouldEmitEmittedValue]="true"
                                    [disabled]="workspaceOwnerDetailsDisable"
                                    [createWorkspaceFlag]="true"></app-generic-drop-down>
                            </div>
                            <div>
                                <p class="label">Designation <span class="required-star">*</span></p>
                                <app-generic-drop-down [options]="designationList" (value)="getIdOfDesignation($event)"
                                    selectedValue="" [titleName]="'name'" [valueName]="'id'"
                                    [title]="selectedValue || 'Select Method'" [shouldEmitEmittedValue]="true"
                                    [disabled]="workspaceOwnerDetailsDisable"
                                    [createWorkspaceFlag]="true"></app-generic-drop-down>
                            </div>
                        </div>
                        <div class="owner-image-container">
                            <div class="image-upload-wrapper">
                                <div class="image-preview" (click)="fileInput.click()">
                                    <ng-container *ngIf="previewUrl; else placeholder">
                                        <img [src]="previewUrl" alt="Workspace Owner" />
                                    </ng-container>
                                    <ng-template #placeholder>
                                        <img src="assets/144x144/Profile-picture.svg" alt="Placeholder" />
                                    </ng-template>
                                </div>

                                <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*"
                                    hidden />

                                <div class="upload-link" (click)="fileInput.click()">
                                    <img src="assets/16x16/upload.svg" alt="Upload" />
                                    <span>Upload Workspace Owner’s Image</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="step === 3">
            <div class="wrapper-container">
                <h4>Plan Details</h4>
                <div class="plan-container">
                    <div class="plan-info">
                        <div>
                            <p class="label-form">Plan</p>
                            <app-generic-drop-down [options]="options" title="Select Plan" titleName="name"
                                valueName="id" [shouldEmitEmittedValue]="true"
                                (value)="handleValue($event)"></app-generic-drop-down>
                        </div>
                        <div class="owner-details">
                            <div>
                                <p class="label-form">Owner Name</p>
                                <div class="text">{{owner.firstName + " " + owner.lastName}}</div>
                            </div>
                            <div>
                                <p class="label-form">Owner Email</p>
                                <div class="text">{{owner.email}}</div>
                            </div>
                            <div>
                                <p class="label-form">Phone Number</p>
                                <div class="text">{{owner.phoneNumber}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="button-container">
                        <app-button theme="primary" size="medium" (click)="handleSubmit()">Submit</app-button>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>